import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import WriteExcelForm from '../forms/write-excel-form';
import { excelWriteValidationSchema } from '../schema/excel.js';

export default function WriteExcelNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Write Excel Node Details',
        altText: 'Write Excel Node',
        defaultLabel: 'Write Excel Node',
      }}
    >
      <CommonNode FormComponent={WriteExcelForm} schemaResolver={excelWriteValidationSchema} />
    </NodeProvider>
  );
}
